export const COLORS = {
  BG_MAIN: '#F5F8FF',
};
